import { lenis } from './lenis'

export const linkToSections = () => {

  if (window.location.hash) {
    const anchorValue = window.location.hash.substring(1)
		const targetEl = document.querySelector(`#${anchorValue}`)

		setTimeout(() => {
			lenis.scrollTo(targetEl, {
				duration: 1.5,
				offset: -125
			})
		}, 600)
  } 
}

export default () => {} 